import { render, staticRenderFns } from "./companySelect.vue?vue&type=template&id=36724554"
import script from "./companySelect.vue?vue&type=script&lang=js"
export * from "./companySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports